// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2cFQN","left":"InfoRow_left__3_nkj"};